<template>
  <component
    :is="enabled ? 'router-link' : 'div'"
    :class="['card-header2 user-training-entry', { 'user-training-entry--disabled': !enabled }]"
    :to="enabled ? '/i-miei-allenamenti' : undefined"
    :role="enabled ? undefined : 'link'"
    :aria-disabled="enabled ? undefined : 'true'"
    :aria-busy="loading ? 'true' : undefined"
  >
    <div class="icon-column">
      <span class="material-icons" aria-hidden="true">fitness_center</span>
    </div>
    <div class="text-column">
      <div class="header-text">I tuoi allenamenti</div>
      <div class="text-card" aria-live="polite">{{ description }}</div>
    </div>
    <div v-if="enabled" class="icon-column-right">
      <span class="material-icons" aria-hidden="true">north_east</span>
    </div>
  </component>
</template>
<script>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebaseConfig';
import { loadPublishedTraining } from '@/features/allenamenti/publicationStore';
export default {
  setup() {
    const enabled = ref(false);
    const loading = ref(true);
    const unavailable = ref(false);
    const description = computed(() => loading.value ? 'Verifica disponibilità…'
      : enabled.value ? 'Consulta la tua scheda, gli esercizi e i video.'
      : unavailable.value ? 'Temporaneamente non disponibile.' : 'Nessun allenamento caricato');
    let active = true;
    let sequence = 0;
    let pendingUid = '';

    async function refreshAvailability() {
      const user = auth.currentUser;
      if (!active || !user || pendingUid === user.uid) return;
      const request = ++sequence;
      pendingUid = user.uid;
      loading.value = true;
      unavailable.value = false;
      const stillCurrent = () => active && request === sequence && auth.currentUser?.uid === user.uid;
      try {
        const published = await loadPublishedTraining();
        if (stillCurrent()) enabled.value = !!published?.plan;
      } catch (error) {
        if (stillCurrent()) {
          enabled.value = false;
          unavailable.value = error?.code !== 'training-publication/forbidden';
        }
      } finally {
        if (stillCurrent()) {
          pendingUid = '';
          loading.value = false;
        }
      }
    }

    const unsubscribe = onAuthStateChanged(auth, user => {
      if (!active) return;
      ++sequence;
      pendingUid = '';
      enabled.value = false;
      loading.value = !!user;
      unavailable.value = false;
      if (user) refreshAvailability();
    });

    // A trainer can publish while the client dashboard is already open.
    const onReturn = () => {
      if (typeof document === 'undefined' || document.visibilityState !== 'hidden') refreshAvailability();
    };
    onMounted(() => {
      window.addEventListener('focus', onReturn);
      window.addEventListener('pageshow', onReturn);
      document.addEventListener('visibilitychange', onReturn);
    });
    onBeforeUnmount(() => {
      active = false;
      sequence += 1;
      unsubscribe();
      enabled.value = false;
      window.removeEventListener('focus', onReturn);
      window.removeEventListener('pageshow', onReturn);
      document.removeEventListener('visibilitychange', onReturn);
    });
    return { enabled, loading, description };
  },
};
</script>
<style scoped>
.user-training-entry { color:#fff; text-decoration:none; text-align:left; font-weight:inherit; }
.user-training-entry .text-column { min-width:0; }
.user-training-entry .text-card,
.user-training-entry .material-icons { color:#dedede; }
.user-training-entry:focus-visible { outline:3px solid #fff; outline-offset:3px; }
.card-header2.user-training-entry--disabled,
.card-header2.user-training-entry--disabled:hover { background:#1b1b1b; color:#999; cursor:default; box-shadow:none; transform:none; }
.user-training-entry--disabled .header-text { color:#aaa; }
.user-training-entry--disabled .text-card,
.user-training-entry--disabled .material-icons { color:#8f8f8f; }
</style>
